import './ItemTitleComponent.scss';

export const ItemTitleComponent = ({ Title }) => <span> { Title } </span>;